import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setDispositionState } from '../store/destinationAddress.actions'

export function* getDestinationAddress(pcrDoc: IPcr) {
  const disposition = pcrDoc.disposition
  if (disposition && Object.keys(disposition).length !== 0) {
    yield put(setDispositionState(disposition))
  }
}
